import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from 'prop-types';
import { allReviewsUrl } from '../../../components/Reviews/constants';
import css from './SoldOut.module.scss';
import Assets from '../Assets';
import Rating from '../../../components/Rating'; // import RecommendationsAI from '../../../components/RecommendationsAI';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var SoldOut = function SoldOut(_ref) {
  var _colorways$edges$, _colorways$edges$$nod, _colorways$edges$$nod2, _colorways$edges$$nod3;

  var colorways = _ref.colorways,
      id = _ref.id,
      image = _ref.image,
      properties = _ref.properties,
      rating = _ref.rating,
      shopifyId = _ref.shopifyId,
      title = _ref.title;

  /* removed recommendation as a value between description and reviewCount */
  var description = properties.description,
      reviewCount = properties.reviewCount;
  var allReviews = allReviewsUrl(shopifyId);
  var assets = (colorways === null || colorways === void 0 ? void 0 : (_colorways$edges$ = colorways.edges[0]) === null || _colorways$edges$ === void 0 ? void 0 : (_colorways$edges$$nod = _colorways$edges$.node) === null || _colorways$edges$$nod === void 0 ? void 0 : (_colorways$edges$$nod2 = _colorways$edges$$nod.assets) === null || _colorways$edges$$nod2 === void 0 ? void 0 : (_colorways$edges$$nod3 = _colorways$edges$$nod2.edges) === null || _colorways$edges$$nod3 === void 0 ? void 0 : _colorways$edges$$nod3.slice(0, 2).map(function (_ref2) {
    var node = _ref2.node;
    return node;
  })) || [{
    id: id,
    image: image
  }];
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("section", {
      className: css.root,
      children: [/*#__PURE__*/_jsx(Assets, _objectSpread(_objectSpread({}, properties), {}, {
        assets: assets
      })), /*#__PURE__*/_jsxs("div", {
        className: css.properties,
        children: [/*#__PURE__*/_jsx("h1", {
          className: css.title,
          children: title
        }), reviewCount > 0 && /*#__PURE__*/_jsxs("a", {
          className: css.writeReview,
          href: allReviews,
          children: [/*#__PURE__*/_jsx(Rating, {
            count: 5,
            value: rating,
            size: 12
          }), /*#__PURE__*/_jsx("span", {
            children: "".concat(reviewCount, " review").concat(reviewCount === 1 ? '' : 's')
          })]
        }), !reviewCount && /*#__PURE__*/_jsx("a", {
          className: css.writeReview,
          href: allReviews,
          children: "Write the first review"
        }), /*#__PURE__*/_jsx("p", {
          className: css.description,
          children: description
        }), /*#__PURE__*/_jsx("div", {
          className: css.buttonIsh,
          children: "Sold Out"
        })]
      })]
    })
  });
};

SoldOut.propTypes = {
  colorways: PropTypes.shape({
    edges: PropTypes.arrayOf(PropTypes.shape())
  }),
  id: PropTypes.string.isRequired,
  image: PropTypes.shape().isRequired,
  properties: PropTypes.shape({
    description: PropTypes.string,
    // recommendation: PropTypes.shape(),
    reviewCount: PropTypes.number.isRequired
  }).isRequired,
  rating: PropTypes.number.isRequired,
  shopifyId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired // variantId: PropTypes.number.isRequired,

};
export default SoldOut;